module.exports = __webpack_public_path__ + "img/removals_variant_2x.52dee02.webp";